import { List, Datagrid, TextField, FunctionField } from 'react-admin';

const ExplainerPreview = ({ record }: { record?: { explainer?: string } }) => {
  const text = record?.explainer ?? '';
  const preview = text.length > 80 ? `${text.slice(0, 80)}…` : text;
  return <span title={text}>{preview || '—'}</span>;
};

export const SkillList = (props: any) => (
  <List {...props} sort={{ field: 'order', order: 'ASC' }}>
    <Datagrid rowClick="edit" bulkActionButtons={false}>
      <TextField source="id" label="ID" />
      <TextField source="name" />
      <FunctionField
        label="Explainer (preview)"
        render={(record: any) => <ExplainerPreview record={record} />}
      />
    </Datagrid>
  </List>
);
